<script lang="ts" setup>
  import { useForwardProps, type AccordionItemProps } from 'radix-vue'

  const props = defineProps<AccordionItemProps>()
  const forwardedProps = useForwardProps(props)
</script>

<template>
  <AccordionItem v-bind="forwardedProps">
    <AccordionHeader
      as="div"
      class="m-0 h-auto p-0"
    >
      <AccordionTrigger
        class="align-center flex w-full justify-between border-b-2 border-b-divider py-4 data-[state=open]:border-none"
      >
        <slot
          name="title"
          class="text-bt-blue-dark"
        />

        <div class="rotate-90">
          <Icon name="common/chevron-right" />
        </div>
      </AccordionTrigger>
    </AccordionHeader>
    <AccordionContent class="border-b-2 border-b-divider">
      <div>
        <slot name="content" />
      </div>
    </AccordionContent>
  </AccordionItem>
</template>
